import React, { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import PendingOrdererConfirmsService from './PendingOrdererConfirmsService';
import OrderByOptionService from '../../setting/orderByOption/OrderByOptionService';
import OrdererConfirmModal from '../../../sharedComponents/OrdererConfirmModal';
import { formatDate } from '../../../utils/dateUtils';

const PendingOrdererConfirms = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [orderByOptions, setOrderByOptions] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await PendingOrdererConfirmsService.list();
      setRows(Array.isArray(data) ? data : []);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'โหลดรายการไม่สำเร็จ');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Needed so the modal can list orderers when a row has no LINE match
  // (requireLineGroupLink hold) and matchedOrderers is empty.
  useEffect(() => {
    OrderByOptionService.getActiveOrderByOptions()
      .then((res) => setOrderByOptions(res.data || []))
      .catch(() => setOrderByOptions([]));
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-4 flex justify-between items-center mb-4">
        <h2 className="text-3xl font-semibold">ยืนยัน Orderer ที่ยังค้างอยู่</h2>
        <button
          onClick={load}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          disabled={loading}
        >
          {loading ? 'กำลังโหลด...' : 'รีเฟรช'}
        </button>
      </div>

      <div className="shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              <th className="py-3 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">Order ID</th>
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Smile Name</th>
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Contact</th>
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">URL</th>
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Order Date</th>
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Shop</th>
              <th className="px-3 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {rows.length === 0 && !loading && (
              <tr>
                <td colSpan={7} className="py-6 text-center text-gray-500">
                  ไม่มี order ที่รอยืนยัน orderer
                </td>
              </tr>
            )}
            {rows.map((r) => (
              <tr key={r.orderId}>
                <td className="py-3 pl-4 pr-3 text-sm text-gray-900">{r.orderId}</td>
                <td className="px-3 py-3 text-sm text-gray-700">{r.smileNameInput || '-'}</td>
                <td className="px-3 py-3 text-sm text-gray-700">{r.contact || '-'}</td>
                <td className="px-3 py-3 text-sm text-blue-700 max-w-xs truncate">
                  <a href={r.url} target="_blank" rel="noopener noreferrer">{r.url}</a>
                </td>
                <td className="px-3 py-3 text-sm text-gray-700">{r.orderDate ? formatDate(r.orderDate) : '-'}</td>
                <td className="px-3 py-3 text-sm text-gray-700">{r.shop || '-'}</td>
                <td className="px-3 py-3 text-right">
                  <button
                    onClick={() => setSelected(r)}
                    className="bg-green-500 hover:bg-green-700 text-white text-sm font-semibold py-1.5 px-3 rounded"
                  >
                    ยืนยัน
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <OrdererConfirmModal
        ordererMatch={selected}
        orderByOptions={orderByOptions}
        onConfirmed={() => {
          setSelected(null);
          load();
        }}
      />
    </div>
  );
};

export default PendingOrdererConfirms;
